import React, { PropTypes } from 'react'
import classnames from 'classnames'

import styles from './Container.scss'

const Container = ({ children, className, flush }) => (
  <div className={classnames(styles.container, { [styles.flush]: flush }, className)}>
    {children}
  </div>
)

Container.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  flush: PropTypes.bool,
}

export default Container



// WEBPACK FOOTER //
// ./src/components/Grid/Container/Container.js